import { memo, PropsWithChildren } from 'react';

type Props = PropsWithChildren<{
  url: string;
  openInNewTab?: boolean;
}>;

export const LinkWrapper = memo(
  ({ children, url, openInNewTab = true }: Props) => (
    <a
      href={url}
      className="text-foreground size-full"
      target={openInNewTab ? '_blank' : undefined}
      rel="noopener noreferrer"
    >
      {children}
    </a>
  )
);
